// @flow
import { List, Record, Map as ImmutableMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

// ================================================================================================
// FilterStore - Filter Store Properties & Types
// ================================================================================================

type FiltersStoreProps = QcsSyncResourceStoreProps & {

};

export type FiltersStore = RecordOf<FiltersStoreProps>;

export const mkFiltersStore: RecordFactory<FiltersStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: null,
    loadPending: true,

    isLoading: false,
  });

// ================================================================================================
// FilterItems - FilterItems Store Properties & Types
// ================================================================================================

type FilterItemProps = {
  type: ?string,
}

export type FilterItems = RecordOf<FilterItemProps>;
export const makeFilterItem: RecordFactory<FilterItemProps> =
  Record({
    type: null,
  });


// ================================================================================================
// Filter - Filter Properties & Types
// ================================================================================================

type FilterProps = {
  id: string,
  clientId: ?string,
  isDeleted: ?boolean,
  filterItems: ?List<FilterItems>,
};

export type Filter = RecordOf<FilterProps>;

export const mkFilter: RecordFactory<FilterProps> =
  Record({
    id: null,
    isDeleted: null,
    clientId: null,
    filterItems: null,
  });
